import { render } from "./packdistribute.vue?vue&type=template&id=7a2fbfe4&scoped=true"
import script from "./packdistribute.vue?vue&type=script&lang=js"
export * from "./packdistribute.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2fbfe4"]])

export default __exports__